require('../../modules/es6.array.slice');
module.exports = require('../../modules/_core').Array.slice;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/slice.js
// module id = 482
// module chunks = 2